export default "__VITE_ASSET__DeNsrava__"